import React, {useState, useEffect} from 'react';

import { Link } from "react-router-dom";

import * as vars from './../vars.js';

import Button from 'react-bootstrap/Button';

import { ReactSession } from 'react-client-session';

import uuid from 'react-uuid';
import { sha256, sha224 } from 'js-sha256';

function InternetPackage(props) {

  ReactSession.setStoreType("localStorage");

  const [ourPackage, setOurPackage] = useState(false);


  useEffect(() => {
    
    if(props.info) {
      setOurPackage(props.info.packages[props.packageId]);
    }
    
  });


  function clickPackage(id) {
    

  }


  

  if(props.availability < ourPackage.availableRegion || props.availability > ourPackage.maxRegion) {
    return;
  }

  return (
    <>
    <div className="internetPackage">

      <h3>{ourPackage.name}</h3>
      <div className="packageDesc brand_color_text"><b><i>{ourPackage.marketing_description}</i></b></div>

      <div className={"packageSpeed "+(ourPackage.price>0?'':'hidden')}><b>{ourPackage.download}</b> Mbps down - <b>{ourPackage.upload}</b> Mbps up</div>
      
      <div className={"packagePrice "+(ourPackage.price>0?'':'hidden')}><span className="brand_color_text">${ourPackage.promo_price}<span className="packagePriceSmaller">/mo</span></span></div>
      <div className={""+(ourPackage.price!=ourPackage.promo_price?'':'hidden')}><span className="packagePriceEvenMoreSmallerYet">*Regular Price</span> <span className="brand_color_text">${ourPackage.price}<span className="packagePriceEvenMoreSmallerYet">/mo</span></span></div>
      <div className={"packagePrice "+(ourPackage.oneTimePrice>0?'':'hidden')}><span className="brand_color_text">${ourPackage.oneTimePrice}<span className="packagePriceSmaller"></span></span></div>
      <div className="finePrint">{ourPackage.finePrint}</div>

      {/* Long-form description from the CMS (the "Description" field on
          the plan edit page, not the short tagline above). Empty values
          render nothing so plans without a description don't get a
          stray blank block. */}
      {ourPackage.description ? (
        <div className="packageDetail">{ourPackage.description}</div>
      ) : null}

      {/* Install caveat — shown only when the plan's requires_install
          flag is set in the CMS. The price range is hardcoded here on
          purpose: it's a single string that applies site-wide and isn't
          worth a settings row until it actually varies per-plan. */}
      {ourPackage.requiresInstall ? (
        <div className="packageInstallNote">
          * Requires a one-time installation fee, ranges from $99 – $199.
        </div>
      ) : null}

      <br/><Button onClick={() => { props.clickedOrder()}} variant="warning" size="lg" active>{ourPackage.orderButtonText}</Button>
      <br/><br/><br/><br/>
    <div className="clear"></div>
    </div>
    </>
        );

}
  
export default InternetPackage;